export default "__VITE_ASSET__BIP0DkMx__"